import type { IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { ImportSourceType } from "./types";

export const importSourceIconBgMap: Record<ImportSourceType, string> = {
    list: colorsPalettes.blue[350],
    csv: colorsPalettes.torquoise[300],
    gsc: colorsPalettes.blue[350],
};

export const importSourceIconNameMap: Record<ImportSourceType, IconName> = {
    list: "keyword-group",
    csv: "open-folder",
    gsc: "google-search",
};
